var exports = {
  "p": "AutocompleteChannel.module__channelIcon___ajN5Mn",
};

module.exports = exports;
